var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "d-flex flex-wrap mb-4" }, [
    _c(
      "div",
      { staticClass: "mt-3 d-flex" },
      [
        _vm._l(_vm.imageProps, function(prop) {
          return [
            _c("div", { staticClass: "phywe-icon-up" }, [
              prop.selectionId === 390
                ? _c("img", {
                    directives: [{ name: "tooltip", rawName: "v-tooltip" }],
                    attrs: {
                      src:
                        "https://cdn02.plentymarkets.com/jd5w7us67fek/frontend/Onlineshop/Images/SingleArticleIcons/icon-cobra-4.jpg",
                      "data-toggle": "tooltip",
                      "data-placement": "top",
                      title: "COBRA 4"
                    }
                  })
                : _vm._e(),
              _vm._v(" "),
              prop.selectionId === 391
                ? _c("img", {
                    directives: [{ name: "tooltip", rawName: "v-tooltip" }],
                    attrs: {
                      src:
                        "https://cdn02.plentymarkets.com/jd5w7us67fek/frontend/Onlineshop/Images/SingleArticleIcons/icon-tess.jpg",
                      "data-toggle": "tooltip",
                      "data-placement": "top",
                      title: "TESS"
                    }
                  })
                : _vm._e(),
              _vm._v(" "),
              prop.selectionId === 392
                ? _c("img", {
                    directives: [{ name: "tooltip", rawName: "v-tooltip" }],
                    attrs: {
                      src:
                        "https://cdn02.plentymarkets.com/jd5w7us67fek/frontend/Onlineshop/Images/SingleArticleIcons/icon-demo.jpg",
                      "data-toggle": "tooltip",
                      "data-placement": "top",
                      title: "DEMO"
                    }
                  })
                : _vm._e(),
              _vm._v(" "),
              prop.selectionId === 393
                ? _c("img", {
                    directives: [{ name: "tooltip", rawName: "v-tooltip" }],
                    attrs: {
                      src:
                        "https://cdn02.plentymarkets.com/jd5w7us67fek/frontend/Onlineshop/Images/SingleArticleIcons/icon-cobra-smar-tsense.jpg",
                      "data-toggle": "tooltip",
                      "data-placement": "top",
                      title: "COBRA Smart Sense"
                    }
                  })
                : _vm._e(),
              _vm._v(" "),
              prop.selectionId === 442
                ? _c("img", {
                    directives: [{ name: "tooltip", rawName: "v-tooltip" }],
                    attrs: {
                      src:
                        "https://cdn02.plentymarkets.com/jd5w7us67fek/frontend/Onlineshop/Images/SingleArticleIcons/icon-add-set.jpg",
                      "data-toggle": "tooltip",
                      "data-placement": "top",
                      title: "Aufbauset"
                    }
                  })
                : _vm._e(),
              _vm._v(" "),
              prop.selectionId === 443
                ? _c("img", {
                    directives: [{ name: "tooltip", rawName: "v-tooltip" }],
                    attrs: {
                      src:
                        "https://cdn02.plentymarkets.com/jd5w7us67fek/frontend/Onlineshop/Images/SingleArticleIcons/icon-basic-set.jpg",
                      "data-toggle": "tooltip",
                      "data-placement": "top",
                      title: "Basisset"
                    }
                  })
                : _vm._e(),
              _vm._v(" "),
              prop.selectionId === 435
                ? _c("img", {
                    directives: [{ name: "tooltip", rawName: "v-tooltip" }],
                    attrs: {
                      src:
                        "https://cdn02.plentymarkets.com/jd5w7us67fek/frontend/Onlineshop/Images/SingleArticleIcons/icon-nobel.jpg",
                      "data-toggle": "tooltip",
                      "data-placement": "top",
                      title: "Nobelpreisexperiment"
                    }
                  })
                : _vm._e(),
              _vm._v(" "),
              prop.selectionId === 1
                ? _c("img", {
                    directives: [{ name: "tooltip", rawName: "v-tooltip" }],
                    attrs: {
                      src:
                        "https://cdn02.plentymarkets.com/jd5w7us67fek/frontend/Onlineshop/Images/SingleArticleIcons/icon-digital.jpg",
                      "data-toggle": "tooltip",
                      "data-placement": "top",
                      title: "Digital"
                    }
                  })
                : _vm._e(),
              _vm._v(" "),
              prop.selectionId === 2
                ? _c("img", {
                    directives: [{ name: "tooltip", rawName: "v-tooltip" }],
                    attrs: {
                      src:
                        "https://cdn02.plentymarkets.com/jd5w7us67fek/frontend/Onlineshop/Images/SingleArticleIcons/icon-analog.jpg",
                      "data-toggle": "tooltip",
                      "data-placement": "top",
                      title: "Analog"
                    }
                  })
                : _vm._e()
            ])
          ]
        })
      ],
      2
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }